import React from 'react';
import IconGoogle from '@images/svg/google-icon.svg';
import { colors } from '../primitives/colors';
import { borderRadius } from '../primitives/tokens';
import Link from "../primitives/link";

const LeaveUsAReview = ({
    googleReviewLink
}) => {
    if(!googleReviewLink) {
        return null
    }
    return (<Link
        css={{
            display: 'inline-flex',
            width: 'fit-content',
            alignItems: 'center',
            margin: '10px 0',
            border: `1px solid ${colors.grey300}`,
            borderRadius: borderRadius.small,
            backgroundColor: colors.shadesWhite,
            '&.hover-default:hover' : {
                opacity: 1,
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                transition: 'box-shadow 0.2s ease-out',
            }
        }}
        to={googleReviewLink}
    >
        <IconGoogle
            css={{
                padding: 6,
                borderBottomLeftRadius: borderRadius.small,
                borderTopLeftRadius: borderRadius.small,
                borderRight: `1px solid ${colors.grey200}`,
            }}
            height={32}
            width={32}
        />
        <span css={{ padding: '4px 15px', color: colors.grey500 }}>Leave us a review</span>
    </Link>
    );
};

export default LeaveUsAReview;
